import styled from 'styled-components';

export const StyledTableSortingIndicator = styled.span`
	display: flex;
	flex-direction: column;
	width: 8px;
	margin: 0;
`;
